module.exports = __webpack_public_path__ + "static/media/4-d.fea3c890.png";